import React from 'react';
import './Navbar.scss';
import logo from '../../img/logo.svg';
import { ProductConsumer } from '../../../Context';

const Navbar = () => (
  <nav className='navbar'>
    <ProductConsumer>
      {value => {
        return (
          <div className='navbar__elements'>
            <img
              className='navbar__elements__logo'
              src={logo}
              alt='corgi head logo'
              onClick={value.backToProducts}
            />
            <h1
              className='navbar__elements__header'
              onClick={value.backToProducts}
            >
              Corgis & More
            </h1>
          </div>
        );
      }}
    </ProductConsumer>
  </nav>
);

export default Navbar;
